import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from "rxjs/operators";
import { DocumentoNegociable } from "../../models/DocumentoNegociable";
import { NgxXml2jsonService } from "ngx-xml2json";
import { AccesoService } from '../acceso/acceso.service';
import { environment } from '../../../environments/environment';
import { FiltrosDocumentosNegociables } from '../../models/FiltrosDocumentosNegociables';
import { FiltrosDnProveedor } from 'src/app/models/FiltrosDnProveedor';
import { FiltrosDnAdquirente } from 'src/app/models/FiltrosDnAdquirente';

@Injectable({
  providedIn: "root"
})
export class DocumentoService {
  
  // ------ variables para el paso de datos entre documentos negociables y adjuntar archivos
  tipoAdjunto :number;
  tipoEmision : string ;
  // ------
  prov:any =[];
  adq:any = [];
  provSwicht:boolean;
  adqSwicht:boolean ;
  xml2: JSON;
  datos:any = [];
  idEmpresa_Factor:any;
  readonly urlBase =  environment.rutaBase;
  //readonly urlBase =  "http://localhost:9095";
  header : HttpHeaders;
  constructor(
    private http: HttpClient,
    private ngxXml2jsonService: NgxXml2jsonService,
    private accesoService :AccesoService,
    // private env = environment

  ) {
  }

  obtenerIDEmpresa(){
    this.idEmpresa_Factor= environment.ID_EMPRESA; //JSON.parse(sessionStorage.getItem('UserActive')).id_empresa;
  }

  obtenerDocNegociablesAdq(idAdquirente:any,Filtros:FiltrosDnAdquirente) {
    this.obtenerIDEmpresa();
    let headers = this.accesoService.desencriptarTOKEN();
    return this.http
      .get(
        `${this.urlBase}/DNExtranet?idEmpresa_Factor=${this.idEmpresa_Factor}&idAdquirente=${idAdquirente}&FechaInicial=${Filtros.FechaIni}&FechaFinal=${Filtros.FechaFin}&NumeroPagina=1&NumeroRegistro=500`,{headers}
      )
      .pipe(
        map((data) => {
        this.datos = data;
         return data;
        })
      );
    //let headers :  HttpHeaders = new HttpHeaders();
    //headers =  headers.append('Accept', 'application/json');
   // headers =  headers.append('Authorization', `XQgkmtsxwbPn6nWs`);
    //return this.http.get(`http://localhost:2528/api-comprobante/DNExtranet?idEmpresa_Factor=${this.idEmpresa_Factor}&idAdquirente=${idAdquirente}&idProveedor=${Filtros.IdProv}&FechaInicial=${Filtros.FechaIni}&FechaFinal=${Filtros.FechaFin}&Estado=${Filtros.Estado}&NumeroPagina=1&NumeroRegistro=50`,{ headers } ).
    //pipe(
      //map((data) => {
        //this.datos = data;
        //return data;
      //})
    //);
  }

  obtenerDocNegociables(idproveedor:any, Filtros:FiltrosDnProveedor) {
    this.obtenerIDEmpresa();
    let headers = this.accesoService.desencriptarTOKEN();
    return this.http
      .get(
        `${this.urlBase}/DNExtranet?idEmpresa_Factor=${this.idEmpresa_Factor}&idProveedor=${idproveedor}&FechaInicial=${Filtros.FechaIni}&FechaFinal=${Filtros.FechaFin}&NumeroPagina=1&NumeroRegistro=500`,{headers}
      )
      .pipe(
        map((data) => {
         this.datos = data;
         return data;
        })
      );
    //let headers :  HttpHeaders = new HttpHeaders();
    //headers =  headers.append('Accept', 'application/json');
   //headers =  headers.append('Authorization', `XQgkmtsxwbPn6nWs`);
   // return this.http.get(`http://localhost:2528/api-comprobante/DNExtranet?idEmpresa_Factor=${this.idEmpresa_Factor}&idProveedor=${idproveedor}&idAdquirente=${Filtros.IdAdq}&FechaInicial=${Filtros.FechaIni}&FechaFinal=${Filtros.FechaFin}&Estado=${Filtros.Estado}&NumeroPagina=1&NumeroRegistro=50`,{ headers } ).
    //pipe(
     // map((data) => {
        //this.datos = data;
        //eturn data;
      //})
    //);
  }
  obtenerDocNegociablesById(idComprobante: any) {
    this.obtenerIDEmpresa();
    let headers = this.accesoService.desencriptarTOKEN();
    return this.http
      .get(
        `${this.urlBase}/comprobante/${idComprobante}?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers}
      )
      .pipe(
        map((data) => {
         this.datos = data;
         return data;
        })
      );

  }
  FiltrarDatosListadoDocNegociables(Filtros :FiltrosDocumentosNegociables ){
    this.obtenerIDEmpresa();
    let headers = this.accesoService.desencriptarTOKEN();

    return this.http
      .get(
        `${this.urlBase}/comprobante?idEmpresa_Factor=${this.idEmpresa_Factor}&NumeroPagina=1&NumeroRegistro=100000&NumeroCp=${Filtros.Numero}&ExisteAdjunto=${Filtros.Adjunto}&Tipo_Emision=${Filtros.Tipo_Emision}&Tipo_Comprobante=${Filtros.Tipo_Comprobante}&idProveedor=${Filtros.Id}&Estado=${Filtros.Estado}`,{headers}
      )
      .pipe(
        map((data) => {
          this.datos = data;
          return data;
        })
      );
  }
  validarEmpresaExistente(ruc: string , serie? :string ) {
    this.obtenerIDEmpresa();
    let headers = this.accesoService.desencriptarTOKEN();
    if (serie){

      return this.http
        .get(`${this.urlBase}/empresas/p?Ruc=${ruc}&Serie=${serie}&idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers})
        .pipe(
          map(data => {
            // console.log('data', data)
            return data[0];
          })
        );
    }else {


      return this.http
        .get(`${this.urlBase}/empresas/g?idEmpresa_Factor=${this.idEmpresa_Factor}&Num_Doc_Identificacion=${ruc}`,{headers})
        .pipe(
          map(data => {
            console.log('data', data)
            // console.log('data', data)
            return data[0];
          })
        );

    }


  }

  validarEmpresaExistentePROV(ruc: string) {
    this.obtenerIDEmpresa();
    let headers = this.accesoService.desencriptarTOKEN();

    return this.http
      .get(`${this.urlBase}/empresas/p?Ruc=${ruc}&idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers})
      .pipe(
        map(data => {
          // console.log('data', data)
          return data[0];
        })
      );
  }
  validarEmpresaExistenteADQ(ruc: string) {
    this.obtenerIDEmpresa();
    let headers = this.accesoService.desencriptarTOKEN();

    return this.http
      .get(`${this.urlBase}/empresas/a?Ruc=${ruc}&idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers})
      .pipe(
        map(data => {
          // console.log('data', data)
          return data[0];
        })
      );
  }
  crearDocNegociable(data: any) {
    this.obtenerIDEmpresa();
    let headers = this.accesoService.desencriptarTOKEN();

    return this.http.post(
      `${this.urlBase}/comprobante?idEmpresa_Factor=${this.idEmpresa_Factor}`,

      data,{headers}
    );
  }
  actualizarDocNegociable(data: DocumentoNegociable, idComprobante? : any){
    this.obtenerIDEmpresa();
    let headers = this.accesoService.desencriptarTOKEN();
    return this.http.put(`${this.urlBase}/comprobante/${idComprobante}?idEmpresa_Factor=${this.idEmpresa_Factor}`,data,{headers});
  }
  crearCuotas( body : any , idComprobante? : number ){
    this.obtenerIDEmpresa();
    let headers = this.accesoService.desencriptarTOKEN();
    return this.http.put(`${this.urlBase}/comprobante/cuota/${idComprobante}?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers});
  }
  toXml(url: any): JSON {
    let xml2 = url;
    let newURL = url.substring(url.indexOf("<Invoice"),url.indexOf("</Invoice")+10);
    
    let newyrl6 = this.clearXML(xml2);
    let newyrl7 = this.clearXML(newURL);

    const parser = new DOMParser();
    
    const xml = parser.parseFromString(newyrl6, "text/xml");    
    const obj = this.ngxXml2jsonService.xmlToJson(xml);

    const xml3 = parser.parseFromString(newyrl7, "text/xml");
    const obj2 = this.ngxXml2jsonService.xmlToJson(xml3);

    this.xml2 = obj["AttachedDocument"];
    this.xml2["invoice"] = obj2;

    return this.xml2;
  }
  clearXML(url: any) {
    let xml2 = url;
    
    let CDATA = /\<\!\[CDATA\[/gi;
    let newyrl = xml2.replace(CDATA, "");

    let CORCHETE = /\]\]\>/gi;
    let newurl2 = newyrl.replace(CORCHETE, "");

    let AMPERSAND = /&/gi;
    let newyrl3 = newurl2.replace(AMPERSAND, "&amp;");

    let CAC = /cac:/gi;
    let newyrl4 = newyrl3.replace(CAC, "");

    let CBC = /cbc:/gi;
    let newyrl5 = newyrl4.replace(CBC, "");
    

    CBC = /sts:/gi;
     newyrl5 = newyrl5.replace(CBC, "");
     CBC = /ds:/gi;
      newyrl5 = newyrl5.replace(CBC, "");
      CBC = /xades:/gi;
       newyrl5 = newyrl5.replace(CBC, "");
       CBC = /ext:/gi;
        newyrl5 = newyrl5.replace(CBC, "");


    let BR = /\<BR\>/gi;
    let newyrl6 = newyrl5.replace(BR, "");

   

    return newyrl6;
  }
  guardarArchivoGDrive(body : any){
    this.obtenerIDEmpresa();
    let headers = this.accesoService.desencriptarTOKEN();

    return this.http.post(`${this.urlBase}/comprobante/adjunto?idEmpresa_Factor=${this.idEmpresa_Factor}` , body, {headers})

  }
  cargaMasiva(body:any,tipo:any){ 
    this.obtenerIDEmpresa();
    let headers = this.accesoService.desencriptarTOKEN();
  
    return  this.http.post(`${this.urlBase}/comprobante/carga-masiva/${tipo}?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
    .pipe( 
     map ( (data) => {
            return data;
          })) 
   }
}
